<template>
    <div>
        <ScrollTop />
        <ScrollPanel style="height: 600px">
            <!-- DIALOGO DE LOADING -->
            <Dialog :visible.sync="loading" :closable="false" :containerStyle="{ width: '300px' }">
                <ProgressBar mode="indeterminate" style="height: .5em" />
                <div
                    class="scalein animation-duration-2000 animation-iteration-infinite flex align-items-center justify-content-center font-bold border-round m-2 px-5 py-3">
                    {{ loadingMensaje }}</div>
            </Dialog>
            <!-- DIALOG DEL CORREO -->
            <Dialog :visible.sync="dialogCorreo" :style="{ width: '800px' }" :closable="false">
                <Card>
                    <template #header>
                        <div class="flex justify-content-between flex-wrap pb-2">
                            <Button @click="closeDialogCorreo"> Cerrar</Button>
                            Enviar comprobante
                            <Button @click="enviaCorreo"> Enviar</Button>
                        </div>
                    </template>
                    <template #content>
                        <div class="p-d-flex justify-center p-fluid grid formgrid col-12">
                            <div class="field col-12">
                                <span class="p-float-label">
                                    <InputText v-model="correo.asunto" type="text" />
                                    <label>Asunto</label>
                                </span>
                            </div>
                        </div>
                        <InlineMessage severity="info">Para agregar un DESTINATARIO primero agregue un NOMBRE y un
                            CORREO</InlineMessage>
                        <div class="p-d-flex justify-center p-fluid grid formgrid col-12">
                            <div class="field col-6">
                                <span class="p-float-label">
                                    <InputText v-model="nuevoDestinatario.nombre" type="text" ref="nombreF" />
                                    <label>Nombre</label>
                                </span>
                            </div>
                            <div class="field col-6">
                                <div class="p-inputgroup">
                                    <span class="p-float-label">
                                        <InputText v-model="nuevoDestinatario.correo" type="text"
                                            @keydown.enter="pushCorreo()" />
                                        <label>Correo</label>
                                    </span>
                                    <Button icon="pi pi-plus" class="p-button-success" @click="pushCorreo" />
                                </div>
                            </div>
                        </div>
                        <div class="p-d-flex justify-center p-fluid grid formgrid col-12">
                            <div class="field col-12">
                                <span class="p-float-label">
                                    <Chips v-model="destinatarios" :allowDuplicate="false">
                                        <template #chip="slotProps">
                                            <div>
                                                <span style="font-size: 12px">{{ slotProps.value.nombre }} - {{
                                                    slotProps.value.correo
                                                }}</span>
                                            </div>
                                        </template>
                                    </Chips>
                                    <label>Destinatarios</label>
                                </span>
                            </div>
                        </div>
                        <Editor v-model="correo.mensaje" editorStyle="height: 500px" />
                    </template>
                </Card>
            </Dialog>
            <Card>
                <template #header>
                    <Button class="mr-1" @click="closeDialogPdf"> Cerrar</Button>
                    <Button class="mr-1" @click="descargaComprobanteXml"> Descargar XML</Button>
                    <Button class="mr-1" @click="descargaComprobante"> Descargar PDF</Button>
                    <Button class="mr-1" @click="openDialogCorreo"> Enviar</Button>
                    <Button class="mr-1" @click="imprimirComprobante"> Imprimir</Button>
                </template>
            </Card>
            <Card>
                <template #content>
                    <div id="invoice">
                        <!-- CABECERA DEL COMPROBANTE -->
                        <div class="p-d-flex justify-center p-fluid grid formgrid col-12">
                            <div class="md:col-6">
                                <a href="https://contago.com.mx/" target="_blank">
                                    <img :src="datosEmpresa.logo.base64" width="250">
                                </a>
                            </div>
                            <div class="md:col-6 text-right">
                                <font size="4">
                                    <div><strong>Comercio Exterior</strong></div>
                                </font>
                                <font size="3">
                                    <div>{{ datosEmpresa.rfc }}</div>
                                </font>
                                <font size="3">
                                    <div>{{ datosEmpresa.nombre }}</div>
                                </font>
                                <font size="2">
                                    <div>{{ datosEmpresa.regimenFiscal.regimenFiscal }}</div>
                                </font>
                            </div>
                        </div>
                        <!-- DATOS DEL CLIENTE -->
                        <div class="grid">
                            <div class="col text-left">
                                <font size="3">
                                    <div>Client Data:</div>
                                </font>
                                <font size="3">
                                    <div><strong>{{ item.cliente.cliente }}</strong></div>
                                </font>
                                <font size="1">
                                    <div>{{ item.cliente.regimenFiscal.regimenFiscal }}</div>
                                </font>
                                <font size="2">
                                    <div>{{ item.cliente.usoCfdi.usoCfdi }}</div>
                                </font>
                                <font size="2">
                                    <div>{{ item.cliente.domicilioFiscal }}</div>
                                </font>
                                <font size="2">
                                    <div>{{ item.cliente.direccion }}</div>
                                </font>
                            </div>
                            <div class="col text-right">
                                <h3>{{ item.serie }} {{ item.folio }}</h3>
                                <div>Date: {{ formatDate(item.fecha) }}</div>
                                <div>Currency: {{ item.moneda.clave }}</div>
                                <div>Voucher Type: I | Ingreso</div>
                                <div>Expedition Place: {{ datosEmpresa.domicilioFiscal }}</div>
                                <div><b>OC: </b>{{ item.ordenCompra }}</div>
                            </div>
                        </div>
                        <!-- DATOS DEL PAGO -->
                        <div class="grid">
                            <div class="col text-center">
                                <p class="font-bold" style="font-size: 12px">Payment Method</p>
                                <p style="font-size: 12px">{{ item.metodoPago.metodoPago }}</p>
                            </div>
                            <div class="col text-center">
                                <p class="font-bold" style="font-size: 12px">Payment Method</p>
                                <p style="font-size: 12px">{{ item.formaPago.formaPago }}</p>
                            </div>
                            <div class="col text-center">
                                <p class="font-bold" style="font-size: 12px">Payment Conditions</p>
                                <p style="font-size: 12px">{{ item.condicionesPago }}</p>
                            </div>
                        </div>
                        <!-- DOCUMENTOS RELACIONADOS -->
                        <div v-if="item.cfdiRelacionados[0].cfdiRelacionados.length != 0">
                            <div class="grid">
                                <div v-for="rel in item.cfdiRelacionados" :key="rel.item">
                                    <DataTable class="mt-1" :value="rel.cfdiRelacionados">
                                        <template #header>
                                            {{ rel.tipoRelacion.tipoRelacion }}
                                        </template>
                                        <Column field="serie" header="Serie"
                                            :styles="{ 'flex-grow': '1', 'flex-basis': '100px', 'font-size': '65%' }">
                                        </Column>
                                        <Column field="folio" header="Folio"
                                            :styles="{ 'flex-grow': '1', 'flex-basis': '100px', 'font-size': '65%' }">
                                        </Column>
                                        <Column field="fecha" header="Fecha"
                                            :styles="{ 'flex-grow': '1', 'flex-basis': '150px', 'font-size': '65%' }">
                                        </Column>
                                        <Column field="rfc" header="RFC"
                                            :styles="{ 'flex-grow': '1', 'flex-basis': '150px', 'font-size': '65%' }">
                                        </Column>
                                        <Column field="nombre" header="Nombre"
                                            :styles="{ 'flex-grow': '1', 'flex-basis': '150px', 'font-size': '65%' }">
                                        </Column>
                                        <Column field="subTotal" header="SubTotal"
                                            :styles="{ 'flex-grow': '1', 'flex-basis': '100px', 'font-size': '65%', 'text-align': 'right' }">
                                            <template #body="{ data }">
                                                <span>{{ formatCurrency(data.subTotal) }}</span>
                                            </template>
                                        </Column>
                                        <Column field="total" header="Total"
                                            :styles="{ 'flex-grow': '1', 'flex-basis': '100px', 'font-size': '65%', 'text-align': 'right' }">
                                            <template #body="{ data }">
                                                <span>{{ formatCurrency(data.total) }}</span>
                                            </template>
                                        </Column>
                                        <Column field="uuid" header="FolioFiscal"
                                            :styles="{ 'flex-grow': '1', 'flex-basis': '150px', 'font-size': '65%' }">
                                        </Column>
                                    </DataTable>
                                    <hr color="#FF9100">
                                </div>
                            </div>
                        </div>
                        <!-- CONCEPTOS -->
                        <DataTable class="mt-1" :value="item.conceptos">
                            <Column field="descripcion" header="Description" class="flex"
                                :styles="{ 'flex-grow': '1', 'flex-basis': '150px', 'font-size': '90%' }">
                                <template #body="{ data }">
                                    <!-- <h4>{{ data.descripcion }}</h4> -->
                                    <Editor readonly :value="separar(data.descripcion)" class="ed editor">
                                        <template hidden #toolbar>
                                            <span hidden class="ql-formats">
                                            </span>
                                        </template>
                                    </Editor>
                                    <div>{{ data.claveProdServ.claveProdServ }}</div>
                                </template>
                            </Column>
                            <Column field="cantidad" header="Quantity"
                                :styles="{ 'flex-grow': '1', 'flex-basis': '100px', 'font-size': '90%' }">
                            </Column>
                            <Column field="claveUnidad.claveUnidad" header="Unit of Measurement"
                                :styles="{ 'flex-grow': '1', 'flex-basis': '100px', 'font-size': '90%' }">
                            </Column>
                            <Column field="valorUnitario" header="Unit Cost"
                                :styles="{ 'flex-grow': '1', 'flex-basis': '100px', 'font-size': '90%', 'text-align': 'right' }">
                                <template #body="{ data }">
                                    <span>{{ formatCurrency(data.valorUnitario) }}</span>
                                </template>
                            </Column>
                            <Column field="importe" header="Amount"
                                :styles="{ 'flex-grow': '1', 'flex-basis': '100px', 'font-size': '90%', 'text-align': 'right' }">
                                <template #body="{ data }">
                                    <span>{{ formatCurrency(data.importe) }}</span>
                                </template>
                            </Column>
                        </DataTable>
                        <!-- SUMAS DE IMPORTES E IMPORTE CON LETRA -->
                        <div class="grid">
                            <div class="col-8 text-left">
                                <p style="font-size: 12px"><strong>Amount With Letter: </strong> {{ importeLetra }}</p>
                                <br>
                                <template v-if="item.timbreFiscalDigital.folioFiscal != ''">
                                    <p style="font-size: 12px"><strong>Certification Date: </strong> {{
                                        item.timbreFiscalDigital.fechaTimbrado
                                    }}</p>
                                    <p style="font-size: 12px"><strong>Certificate Number: </strong> {{
                                        item.timbreFiscalDigital.noCertificado
                                    }}</p>
                                    <p style="font-size: 12px"><strong>Certificate Number SAT: </strong> {{
                                        item.timbreFiscalDigital.noCertificadoSAT
                                    }}</p>
                                    <p style="font-size: 13px"> <strong>Fiscal Folio: </strong> {{
                                        item.timbreFiscalDigital.folioFiscal
                                    }}</p>
                                </template>
                            </div>
                            <div class="col-4">
                                <DataTable :value="itemsImpuestos" class="ocult">
                                    <Column field="impuesto" header=""
                                        :styles="{ 'flex-grow': '1', 'flex-basis': '100px', 'font-size': '80%' }">
                                    </Column>
                                    <Column field="importe" header=""
                                        :styles="{ 'flex-grow': '1', 'flex-basis': '100px', 'font-size': '80%', 'text-align': 'right' }">
                                        <template #body="{ data }">
                                            <span>{{ formatCurrency(data.importe) }}</span>
                                        </template>
                                    </Column>
                                </DataTable>
                            </div>
                        </div>
                        <!-- COMPLEMENTO COMERCIO EXTERIOR -->
                        <div class="field col-12 text-center">
                            <h1 style="background: #FF9100;color: white;font-size: 16px;font-family: arial;">
                                COMPLEMENTO COMERCIO EXTERIOR
                            </h1>
                        </div>
                        <div class="grid">
                            <template v-if="item.comercio.motivoTraslado.clave != ''">
                                <div class="col text-center">
                                    <p class="font-bold" style="font-size: 12px">Motivo de Traslado</p>
                                    <p style="font-size: 12px">{{ item.comercio.motivoTraslado }}</p>
                                </div>
                            </template>
                            <div class="col text-center">
                                <p class="font-bold" style="font-size: 12px">Type of Operation</p>
                                <p style="font-size: 12px">{{ item.comercio.tipoOperacion.tipoOperacion }}
                                </p>
                            </div>
                            <div class="col text-center">
                                <p class="font-bold" style="font-size: 12px">Motion Key</p>
                                <p style="font-size: 12px">{{ item.comercio.claveDePedimento.claveDePedimento }}</p>
                            </div>
                        </div>
                        <hr size=12 color="#FF9100">
                        <div class="grid">
                            <div class="col text-center">
                                <p class="font-bold" style="font-size: 12px">Certificate of Origin</p>
                                <p style="font-size: 12px">{{ item.comercio.certificadoOrigen.certificadoOrigen }}</p>
                            </div>
                            <template v-if="item.comercio.numCertificadoOrigen != ''">
                                <div class="col text-center">
                                    <p class="font-bold" style="font-size: 12px">Certificate of Origin Number</p>
                                    <p style="font-size: 12px">{{ item.comercio.numCertificadoOrigen }}</p>
                                </div>
                            </template>
                            <template v-if="item.comercio.numeroExportadorConfiable != ''">
                                <div class="col text-center">
                                    <p class="font-bold" style="font-size: 12px">Reliable Exporter Number</p>
                                    <p style="font-size: 12px">{{ item.comercio.numeroExportadorConfiable }}</p>
                                </div>
                            </template>
                            <div class="col text-center">
                                <p class="font-bold" style="font-size: 12px">INCOTERM</p>
                                <p style="font-size: 12px">{{ item.comercio.incoterm.incoterm }}</p>
                            </div>
                            <div class="col text-center">
                                <p class="font-bold" style="font-size: 12px">Subdivision</p>
                                <p style="font-size: 12px">{{ item.comercio.subdivision }}</p>
                            </div>
                        </div>
                        <div class="grid">
                            <template v-if="item.comercio.observaciones != ''">
                                <div class="col text-center">
                                    <p class="font-bold" style="font-size: 12px">Observations</p>
                                    <p style="font-size: 12px">{{ item.comercio.observaciones }}</p>
                                </div>
                            </template>
                        </div>
                        <hr size=12 color="#FF9100">
                        <div class="grid">
                            <div class="p-d-flex justify-center p-fluid grid formgrid col-12">
                                <!-- TOTAL TIPO CAMBIO USD -->
                                <div class="field col-12 md:col-6">
                                    <span class="p-float-label">
                                        <InputNumber mode="decimal" locale="en-US" :minFractionDigits="4"
                                            class="p-inputtext-sm" v-model="item.comercio.tipoCambioUSD" />
                                        <label>Exchange Rate USD</label>
                                    </span>
                                </div>
                                <!-- TOTAL USD -->
                                <div class="field col-12 md:col-6">
                                    <span class="p-float-label">
                                        <InputNumber mode="decimal" locale="en-US" :minFractionDigits="2"
                                            class="p-inputtext-sm" v-model="item.comercio.totalUSD" />
                                        <label>Total USD</label>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <!-- DATOS DEL EMISOR Y DEL RECEPTOR -->
                        <div class="grid">
                            <div class="col text-center">
                                <P class="font-bold">Sender</P>
                                <hr size=3 color="#FF9100">
                                <div class="col text-left" style="font-size: 12px">
                                    <p><span class="font-bold">Street: </span>{{
                                        item.comercio.emisor.domicilio.calle
                                    }}
                                    </p>
                                    <p><span class="font-bold">Outdoor Number: </span>{{
                                        item.comercio.emisor.domicilio.numeroExterior
                                    }}</p>
                                    <p><span class="font-bold">Interior Number: </span>{{
                                        item.comercio.emisor.domicilio.numeroInterior
                                    }}</p>
                                    <p><span class="font-bold">Colonia: </span>{{
                                        item.comercio.emisor.domicilio.colonia.colonia
                                    }}</p>
                                    <p><span class="font-bold">Localidad: </span>{{
                                        item.comercio.emisor.domicilio.localidad.localidad
                                    }}</p>
                                    <p><span class="font-bold">Reference: </span>{{
                                        item.comercio.emisor.domicilio.referencia
                                    }}</p>
                                    <p><span class="font-bold">City: </span>{{
                                        item.comercio.emisor.domicilio.municipio.municipio
                                    }}</p>
                                    <p><span class="font-bold">State: </span>{{
                                        item.comercio.emisor.domicilio.estado.estado
                                    }}</p>
                                    <p><span class="font-bold">Country: </span>{{
                                        item.comercio.emisor.domicilio.pais.pais
                                    }}</p>
                                    <p><span class="font-bold">Zip Code: </span>{{
                                        item.comercio.emisor.domicilio.codigoPostal
                                    }}</p>
                                </div>
                            </div>
                            <div class="col text-center">
                                <P class="font-bold">Receiver</P>
                                <hr size=3 color="#FF9100">
                                <div class="col text-left" style="font-size: 12px">
                                    <p><span class="font-bold">Street: </span>{{
                                        item.comercio.receptor.domicilio.calle
                                    }}
                                    </p>
                                    <p><span class="font-bold">Outdoor Number: </span>{{
                                        item.comercio.receptor.domicilio.numeroExterior
                                    }}</p>
                                    <p><span class="font-bold">Interior Number: </span>{{
                                        item.comercio.receptor.domicilio.numeroInterior
                                    }}</p>
                                    <p><span class="font-bold">Reference: </span>{{
                                        item.comercio.receptor.domicilio.referencia
                                    }}</p>
                                    <p><span class="font-bold">City: </span>{{
                                        item.comercio.receptor.domicilio.municipio.municipio
                                    }}</p>
                                    <p><span class="font-bold">State: </span>{{
                                        item.comercio.receptor.domicilio.estado.estado
                                    }}</p>
                                    <p><span class="font-bold">Country: </span>{{
                                        item.comercio.receptor.domicilio.pais.pais
                                    }}</p>
                                    <p><span class="font-bold">Zip Code: </span>{{
                                        item.comercio.receptor.domicilio.codigoPostal
                                    }}</p>
                                </div>
                            </div>
                        </div>
                        <!-- PROPIETARIOS -->
                        <div v-if="item.comercio.propietarios.length != 0">
                            <DataTable class="mt-1" :value="item.comercio.propietarios">
                                <template #header>
                                    <span class="font-bold">PROPIETARIOS</span>
                                </template>
                                <Column field="numRegIdTrib" header="NumRegIdTrib"
                                    :styles="{ 'flex-grow': '1', 'flex-basis': '100px', 'font-size': '90%' }">
                                </Column>
                                <Column field="residenciaFiscal.residenciaFiscal" header="ResidenciaFiscal"
                                    :styles="{ 'flex-grow': '1', 'flex-basis': '100px', 'font-size': '90%' }">
                                </Column>
                            </DataTable>
                        </div>
                        <!-- DESTINATARIOS -->
                        <div v-if="item.comercio.destinatarios.length != 0">
                            <DataTable class="mt-1" :value="item.comercio.destinatarios">
                                <template #header>
                                    <span class="font-bold">DESTINATARIOS</span>
                                </template>
                                <Column field="numRegIdTrib" header="NumRegIdTrib"
                                    :styles="{ 'flex-grow': '1', 'flex-basis': '100px', 'font-size': '90%' }">
                                </Column>
                                <Column field="nombre" header="Nombre"
                                    :styles="{ 'flex-grow': '1', 'flex-basis': '100px', 'font-size': '90%' }">
                                </Column>
                            </DataTable>
                        </div>
                        <!-- MERCANCIAS -->
                        <DataTable class="mt-1" :value="item.comercio.mercancias">
                            <template #header>
                                <span class="font-bold">MERCHANDISE</span>
                            </template>
                            <Column field="noIdentificacion" header="Identification Number"
                                :styles="{ 'flex-grow': '1', 'flex-basis': '100px', 'font-size': '80%' }">
                            </Column>
                            <Column field="fraccionArancelaria.fraccion" header="Tariff Fraction"
                                :styles="{ 'flex-grow': '1', 'flex-basis': '100px', 'font-size': '80%' }">
                            </Column>
                            <Column field="cantidadAduana" header="Customs Quantity"
                                :styles="{ 'flex-grow': '1', 'flex-basis': '100px', 'font-size': '80%', 'text-align': 'right' }">
                                <template #body="{ data }">
                                    <span>{{ formatCantidad(data.cantidadAduana) }}</span>
                                </template>
                            </Column>
                            <Column field="unidadAduana.unidadAduana" header="Customs Unit"
                                :styles="{ 'flex-grow': '1', 'flex-basis': '100px', 'font-size': '80%' }">
                            </Column>
                            <Column field="valorUnitarioAduana" header="Customs Unit Value"
                                :styles="{ 'flex-grow': '1', 'flex-basis': '100px', 'font-size': '80%', 'text-align': 'right' }">
                                <template #body="{ data }">
                                    <span>{{ formatCurrency(data.valorUnitarioAduana) }}</span>
                                </template>
                            </Column>
                            <Column field="valorDolares" header="Value in Dollars"
                                :styles="{ 'flex-grow': '1', 'flex-basis': '100px', 'font-size': '80%', 'text-align': 'right' }">
                                <template #body="{ data }">
                                    <span>{{ formatCurrency(data.valorDolares) }}</span>
                                </template>
                            </Column>
                        </DataTable>
                        <!-- FOLIO  FISCAL -->
                        <template v-if="item.timbreFiscalDigital.folioFiscal != ''">
                            <div class="grid">
                                <div class="col-3">
                                    <a href="https://contago.com.mx/" target="_blank">
                                        <img :src="imagenQR" width="160">
                                    </a>
                                </div>
                                <div class="col-9 text-left" style="word-break: break-all;">
                                    <p class="font-bold" style="font-size: 10px;">
                                        Sello CFDI</p>
                                    <!-- <p style="font-size: 9px">{{ item.timbreFiscalDigital.selloCFDI.base64 }}</p> -->
                                    <div style="font-size: 9px;"><wbr> {{ item.timbreFiscalDigital.selloCFDI.base64 }}
                                    </div>
                                    <p class="font-bold" style="font-size: 10px">Sello SAT</p>
                                    <!-- <p style="font-size: 9px">{{ item.timbreFiscalDigital.selloSAT.base64 }}</p> -->
                                    <div style="font-size: 9px">{{ item.timbreFiscalDigital.selloSAT.base64 }}</div>
                                    <p class="font-bold" style="font-size: 10px">Cadena Original</p>
                                    <!-- <p style="font-size: 9px">{{ item.timbreFiscalDigital.cadenaOriginal }}</p> -->
                                    <div style="font-size: 9px">{{ item.timbreFiscalDigital.cadenaOriginal }}</div>
                                </div>
                            </div>
                        </template>
                        <div class="grid">
                            <div class="col">
                                <p style="font-size: 12px">{{ item.notas }}</p>
                            </div>
                        </div>
                    </div>
                </template>

            </Card>
            <ScrollTop target="parent" :threshold="100" class="custom-scrolltop" icon="pi pi-arrow-up" />
        </ScrollPanel>
    </div>
</template>

<script>
import moment from "moment";
import html2pdf from "html2pdf.js";
import axios from 'axios'
import { numeroALetras } from '../../plugins/numeroALetras.js'
import { numeroALetrasIngles } from '../../plugins/numeroALetrasIngles.js'
import print from 'print-js'

export default {
    components: {
        // numeroALetras,
    },
    data() {
        return {
            dialogCorreo: false,
            loadingMensaje: '',
            loading: false,
            destinatarios: [],
            nuevoDestinatario: {
                nombre: '',
                correo: ''
            }
        };
    },
    computed: {
        item() {
            console.log(this.$store.state.comercioExteriorStore.comercio)
            return this.$store.state.comercioExteriorStore;
        },
        empresa() {
            return this.$store.state.usuario;
        },
        imagenQR() {
            let imagen = 'data:image/jpeg;base64,'
            return imagen + this.$store.state.comercioExteriorStore.timbreFiscalDigital.archioQr
        },
        importeLetra() {
            const func = require('../../plugins/numeroALetrasIngles.js')
            let a = func.numeroALetrasIngles(this.$store.state.comercioExteriorStore.total, this.$store.state.comercioExteriorStore.moneda.clave);
            return a;
        },

        datosEmpresa() {
            return this.$store.state.empresaStore
        },

        itemsImpuestos() {
            var lista = [];
            var subTotal = { impuesto: 'SubTotal', importe: this.$store.state.comercioExteriorStore.subTotal }
            lista.push(subTotal)
            for (var x of this.$store.state.comercioExteriorStore.impuestos.traslados) {
                let nombre = '';
                let tasa = x.tasaOCuota * 100
                tasa = Math.round(tasa * 10000) / 10000
                if (x.impuesto === '001') {
                    nombre = 'ISR'
                }
                if (x.impuesto === '002') {
                    nombre = 'IVA'
                }
                if (x.impuesto === '003') {
                    nombre = 'IEPS'
                }

                nombre = nombre + '(' + tasa + ')%'
                var ob = { impuesto: nombre, importe: x.importe }
                lista.push(ob)
                ob = {};
            }
            for (var x of this.$store.state.comercioExteriorStore.impuestos.retenciones) {
                let nombre = '';
                let tasa = x.tasaOCuota * 100
                tasa = Math.round(tasa * 10000) / 10000
                if (x.impuesto === '001') {
                    nombre = 'ISR'
                }
                if (x.impuesto === '002') {
                    nombre = 'IVA'
                }
                if (x.impuesto === '003') {
                    nombre = 'IEPS'
                }

                nombre = nombre + '(' + tasa + ')%'
                var ob = { impuesto: nombre, importe: (x.importe) * -1 }
                lista.push(ob)
                ob = {};
            }
            var total = { impuesto: 'Total', importe: this.$store.state.comercioExteriorStore.total }
            lista.push(total)
            // console.log(lista)
            return lista;
        },

        correo() {
            return this.$store.state.correoStore
        },

    },
    watch: {

    },
    mounted() {

    },
    created() {
        // this.getCorreo();
    },
    methods: {
        separar(a) {
            // let b = a.replace(/~/g, '<br/>');

            return '<h5>' + a + '</h5>'
        },
        formatDate(date) {
            moment.locale('en')
            let fechaR = moment(date).format("DD-MMMM-yyyy");
            return fechaR;
        },

        formatCurrency(value) {
            return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
        },

        formatCantidad(value) {
            let val = (value / 1).toFixed(3)
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        },

        async exportToPDF() {
            var opt = {
                margin: .5,
                filename: 'ARRENDAMIENTO_' + this.item.serie + "_" + this.item.folio + ".pdf",
                jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' },
                html2canvas: { scale: 4, letterRendering: true, },
                pagebreak: {
                    mode: ['avoid-all', 'css', 'legacy']
                },
                autoPaging: 'text'
            }

            //EXPORTA EL PDF
            html2pdf().from(document.getElementById('invoice')).set(opt).toPdf().get('pdf').then((pdf) => {
                var totalPages = pdf.internal.getNumberOfPages();
                // console.log(totalPages)
                for (let i = 1; i <= totalPages; i++) {
                    pdf.setPage(i);
                    pdf.setFontSize(10);
                    pdf.setTextColor(0);
                    pdf.text(pdf.internal.pageSize.getWidth() - 1,
                        pdf.internal.pageSize.getHeight() - 0.1, 'Página ' + i + " / " + totalPages);
                    pdf.text(pdf.internal.pageSize.getWidth() - 5,
                        pdf.internal.pageSize.getHeight() - 0.1, 'Documento generado por contago');

                    // you can add the line separator as an image, consult the docs below to properly set the place of the image
                    // pdf.addImage(img, 'png', 0, 0, 52, 23)
                }

            }).save();
        },

        async convertBase64() {
            var opt = {
                margin: .5,
                filename: 'PAGO_' + this.item.serie + "_" + this.item.folio + ".pdf",
                jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' },
                html2canvas: { scale: 4, letterRendering: true, },
                pagebreak: {
                    mode: ['avoid-all', 'css', 'legacy']
                },
                autoPaging: 'text'
            }

            //GENRA EL BASE64
            let file = '';
            const jabubu = await html2pdf().from(document.getElementById('invoice')).set(opt).toPdf().get('pdf').then((pdf) => {
                var totalPages = pdf.internal.getNumberOfPages();
                // console.log(totalPages)
                for (let i = 1; i <= totalPages; i++) {
                    pdf.setPage(i);
                    pdf.setFontSize(10);
                    pdf.setTextColor(0);
                    pdf.text(pdf.internal.pageSize.getWidth() - 1,
                        pdf.internal.pageSize.getHeight() - 0.1, 'Página ' + i + " / " + totalPages);
                    pdf.text(pdf.internal.pageSize.getWidth() - 5,
                        pdf.internal.pageSize.getHeight() - 0.1, 'Documento generado por contago');
                }

            }).outputPdf();

            file += btoa(jabubu)
            // console.log(file)
            return 'data:application/pdf;base64,' + file
        },

        async descargaComprobante() {
            await this.exportToPDF()
        },

        openDialogCorreo() {
            this.correo.archivos = []

            this.correo.archivos.push()
            this.dialogCorreo = true;
        },

        closeDialogPdf() {
            this.$emit('cierraDialogPdf')
        },

        closeDialogCorreo() {
            this.dialogCorreo = false;
        },

        async enviaCorreo() {
            this.loading = true;
            this.loadingMensaje = 'Enviando correo...'

            let correos = {
                asunto: this.correo.asunto,
                mensaje: this.correo.mensaje,
                emisor: {
                    nombre: '',
                    correo: '',
                    contra: '',
                    hostt: '',
                    puerto: 0,
                },
                receptores: [],
                archivos: [],
            }


            var xml_ = {
                base64: this.item.timbreFiscalDigital.archivoXml,
                nombre: this.item.folioFiscal + '.xml'
            }
            var pdf_ = {
                base64: await this.convertBase64(),
                nombre: this.item.folioFiscal + '.pdf'
            }

            for (let d of this.destinatarios) {
                var des = {
                    nombre: '',
                    correo: d,
                }
                correos.receptores.push(des)
                des = {}
            }

            correos.archivos.push(xml_);
            correos.archivos.push(pdf_);

            console.log(correos)


            try {
                let response = await axios.post('Correos/PostCorreos/' + this.empresa.empresaBase + '/' + this.empresa.idusuariosApp, correos)
                console.log(response.data)
                this.dialogCorreo = false;
                this.loading = false;
                this.$toast.add({ severity: 'success', detail: 'Correo enviado con éxito', life: 5000 });

            } catch (error) {
                this.$toast.add({ severity: 'error', detail: 'Error al enviar:' + error.response.data, life: 5000 });
                console.log(error)
                this.loading = false;
            }
        },

        async getCorreo() {
            if (this.item.timbreFiscalDigital.uuid != '') {
                this.correo.asunto = 'Se envía factura correspondiente'
            } else {
                this.correo.asunto = 'Se envía documento'
            }
            this.loadingMensaje = 'Espere...'
            this.loading = true
            let idCliente = this.item.cliente.idCliente
            try {
                let response = await axios.get('Correos/GetCorreoContacto/' + this.empresa.empresaBase + '/' + idCliente);
                console.log(response)
                let correos = response.data;
                for (let c of correos) {
                    this.destinatarios.push(c)
                }
                this.loading = false
            } catch (error) {
                console.log(error)
                this.loading = false
            }
        },

        pushCorreo() {
            if (this.nuevoDestinatario.correo === '') {
                this.$toast.add({ severity: 'error', detail: 'Error al agregar destinatario, indique un correo', life: 5000 });
                return
            }
            let nuevo = { ...this.nuevoDestinatario }
            this.destinatarios.push(nuevo)
            let inicializa = {
                nombre: '',
                correo: ''
            }
            this.nuevoDestinatario = { ...inicializa }
            this.$refs.nombreF.$el.focus();
        },
        async descargaComprobanteXml() {
            let archivo = this.item.timbreFiscalDigital.archivoXml;
            let nombreA = this.item.folioFiscal
            this.download(archivo, nombreA, 'xml');
        },
        download(archivo, nombre, tipo) {
            var arrBuffer = this.base64ToArrayBuffer(archivo);
            var newBlob = new Blob([arrBuffer]);

            var data = window.URL.createObjectURL(newBlob);
            var link = document.createElement('a');
            document.body.appendChild(link);
            link.href = data;
            link.download = nombre + '.' + tipo;
            link.click();
            window.URL.revokeObjectURL(data);
            link.remove();
        },
        base64ToArrayBuffer(base64) {
            var binary_string = window.atob(base64);
            var len = binary_string.length;
            var bytes = new Uint8Array(len);
            for (var i = 0; i < len; i++) {
                bytes[i] = binary_string.charCodeAt(i);
            }
            return bytes.buffer;
        },
        async imprimirComprobante() {
            this.loadingMensaje = ''
            this.loading = true

            let documento = await (await this.convertBase64()).split(',')[1];
            //console.log(documento)
            print({
                printable: documento,
                type: 'pdf',
                base64: true,
            })
            this.loading = false

        }
    }
};
</script>
<style>
.col {
    background-color: white;
}

.grid {
    background-color: white;
}

.ocult thead {
    display: none;
}

.ocult table {
    border: none
}

.ed .ql-editor {
    padding: 0px 0px;
}
</style>